// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.TypeIcon {
    align-self: center;
    margin-right: 5px;
}
    .TypeIcon:hover {
        color: black;
    }

.CancelButton {
    align-self: center;
    cursor: pointer
}
.CancelButton:hover {
    color: red;
}

.AcceptButton {
    align-self: center;
    margin-right: 5px;
    cursor: pointer
}
.AcceptButton:hover {
    color: green;
}

.EditButton {
    align-self: center;
    cursor: pointer;
    display: flex;
}

.EditButton:hover {
    color: black;
}

.DeleteButton {
    margin-left: 5px;
    display: flex;
}

.name-input{
    min-width:50px;
}

.infoIcon {
    width: 32px;
    height: 32px;
    border-width: 3px;
    border-style: solid;
    border-radius: 50%;
    position: absolute;
}

.variables {
    border-color: green;
}

.variableIconClip {
    clip: rect(0px, 32px, 16px, 0px);
}

.events {
    border-color: red;
}

.eventIconClip {
    clip: rect(16px, 32px, 32px, 0px);
}

.layoutTreeContent {
    position: relative;
}

    .layoutTreeContent > div > * {
        align-self: center;
    }

.editStack {
    position: absolute;
    right: 0px;
}

.innerDIV {
    min-width: max-content;
    width: 100%;
}

.treeNode {
    height: 48px;
    flex-shrink: 0;
    width: 100%;
    cursor: default;
}

    .treeNode > * {
        flex-shrink: 0;
    }

    .treeNode.selectedNode .treeNodeContent {
        background-color: var(--appbuilder-primary-color);
        color: var(--appbuilder-hover-color);
    }

.treeIcon {
    margin: 0px 4px;
    cursor: grab;
    align-self: center;
    z-index: 1;
}

.toggleDIV {
    width: 24px;
    justify-content: center;
}

.iconDIV {
    display: flex;
    width: 32px;
    position: relative;
    justify-content: center;
}

.iconDIV > * {
    align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/layout.tree.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;IACI;QACI,YAAY;IAChB;;AAEJ;IACI,kBAAkB;IAClB;AACJ;AACA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;IAEI;QACI,kBAAkB;IACtB;;AAEJ;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,iDAAiD;QACjD,oCAAoC;IACxC;;AAEJ;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["\n.TypeIcon {\n    align-self: center;\n    margin-right: 5px;\n}\n    .TypeIcon:hover {\n        color: black;\n    }\n\n.CancelButton {\n    align-self: center;\n    cursor: pointer\n}\n.CancelButton:hover {\n    color: red;\n}\n\n.AcceptButton {\n    align-self: center;\n    margin-right: 5px;\n    cursor: pointer\n}\n.AcceptButton:hover {\n    color: green;\n}\n\n.EditButton {\n    align-self: center;\n    cursor: pointer;\n    display: flex;\n}\n\n.EditButton:hover {\n    color: black;\n}\n\n.DeleteButton {\n    margin-left: 5px;\n    display: flex;\n}\n\n.name-input{\n    min-width:50px;\n}\n\n.infoIcon {\n    width: 32px;\n    height: 32px;\n    border-width: 3px;\n    border-style: solid;\n    border-radius: 50%;\n    position: absolute;\n}\n\n.variables {\n    border-color: green;\n}\n\n.variableIconClip {\n    clip: rect(0px, 32px, 16px, 0px);\n}\n\n.events {\n    border-color: red;\n}\n\n.eventIconClip {\n    clip: rect(16px, 32px, 32px, 0px);\n}\n\n.layoutTreeContent {\n    position: relative;\n}\n\n    .layoutTreeContent > div > * {\n        align-self: center;\n    }\n\n.editStack {\n    position: absolute;\n    right: 0px;\n}\n\n.innerDIV {\n    min-width: max-content;\n    width: 100%;\n}\n\n.treeNode {\n    height: 48px;\n    flex-shrink: 0;\n    width: 100%;\n    cursor: default;\n}\n\n    .treeNode > * {\n        flex-shrink: 0;\n    }\n\n    .treeNode.selectedNode .treeNodeContent {\n        background-color: var(--appbuilder-primary-color);\n        color: var(--appbuilder-hover-color);\n    }\n\n.treeIcon {\n    margin: 0px 4px;\n    cursor: grab;\n    align-self: center;\n    z-index: 1;\n}\n\n.toggleDIV {\n    width: 24px;\n    justify-content: center;\n}\n\n.iconDIV {\n    display: flex;\n    width: 32px;\n    position: relative;\n    justify-content: center;\n}\n\n.iconDIV > * {\n    align-self: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
